import { z } from "zod";

// ── Route 16: POST /api/imports (multipart) ──────────────────────

/**
 * Wire-level response for POST /api/imports.
 * The route returns this at HTTP 201 after ingesting the CSV.
 */
export const ImportsResponse = z.object({
  importId: z.string(),
  rowCount: z.number(),
  pageCount: z.number(),
  storagePath: z.string(),
});
export type ImportsResponse = z.infer<typeof ImportsResponse>;

// ── Route 17: GET /api/analytics-config/:projectId ───────────────

/**
 * Wire-level response for
 * GET /api/analytics-config/[clientId].
 */
export const AnalyticsConfigResponse = z.object({
  client_id: z.string(),
  project_name: z.string(),
  ga4_property_id: z.string().nullable(),
  gsc_site_url: z.string().nullable(),
  shopify_store_domain: z.string().nullable(),
  branded_terms: z.array(z.string()),
  configured: z.boolean(),
});
export type AnalyticsConfigResponse = z.infer<typeof AnalyticsConfigResponse>;

// ── Route 18: POST /api/compute/product-priority ─────────────────

/**
 * Wire-level response for POST /api/compute/product-priority.
 * The route returns { refreshed } on success.
 */
export const ProductPriorityResponse = z.object({
  refreshed: z.string(),
});
export type ProductPriorityResponse = z.infer<typeof ProductPriorityResponse>;

// ── Route 19: GET /api/opportunities/:clientId ───────────────────

/**
 * Single opportunity row returned inside OpportunitiesResponse.
 */
export const Opportunity = z.object({
  opportunity_type: z.string(),
  page_url: z.string(),
  sessions_90d: z.number(),
  conversions_90d: z.number(),
  revenue_90d: z.number(),
  score: z.number(),
  details: z.record(z.unknown()).optional(),
});
export type Opportunity = z.infer<typeof Opportunity>;

/**
 * Wire-level response for GET /api/opportunities/[clientId].
 */
export const OpportunitiesResponse = z.object({
  opportunities: z.array(Opportunity),
});
export type OpportunitiesResponse = z.infer<typeof OpportunitiesResponse>;

// ── Route 20: POST /api/interventions ────────────────────────────

/**
 * Wire-level response for POST /api/interventions.
 * The route returns { intervention: <row> } at HTTP 201.
 * The row shape is the raw DB insert result; we model only the
 * fields the CLI needs to confirm success.
 */
export const InterventionResponse = z.object({
  intervention: z.record(z.unknown()),
});
export type InterventionResponse = z.infer<typeof InterventionResponse>;
